import { render } from "./SharedImageView.vue?vue&type=template&id=28b0c52d&scoped=true"
import script from "./SharedImageView.vue?vue&type=script&lang=js"
export * from "./SharedImageView.vue?vue&type=script&lang=js"

import "./SharedImageView.vue?vue&type=style&index=0&id=28b0c52d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b0c52d"]])

export default __exports__